export default __webpack_public_path__ + "static/media/messageInfo16.5fbc4de8.svg";